import { render, staticRenderFns } from "./BusinessFinancialInstitutions.vue?vue&type=template&id=5127865b"
import script from "./BusinessFinancialInstitutions.vue?vue&type=script&lang=js"
export * from "./BusinessFinancialInstitutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5127865b')) {
      api.createRecord('5127865b', component.options)
    } else {
      api.reload('5127865b', component.options)
    }
    module.hot.accept("./BusinessFinancialInstitutions.vue?vue&type=template&id=5127865b", function () {
      api.rerender('5127865b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/profile/BusinessFinancialInstitutions.vue"
export default component.exports